export function formatDateToDayUTC(date: Date) {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}
export function formatDateToUTC(
  date: Date,
  showSeconds = true,
  showSuffix = true,
) {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  const suffix = showSuffix ? "UTC" : "";

  if (showSeconds) {
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${suffix}`;
  }

  return `${year}-${month}-${day} ${hours}:${minutes} ${suffix}`;
}

export function formatDateToUTCHours(date: Date, showUTC = true) {
  const hours = String(date.getUTCHours()).padStart(2, "0");
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");

  return `${hours}:${minutes}:${seconds} ${showUTC ? "UTC" : ""}`;
}

export function floorToDay(timestamp: number) {
  const date = new Date(timestamp * 1000); // Convert to milliseconds
  date.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
  return Math.floor(date.getTime() / 1000); // Convert back to seconds
}

export function formatPostDate(date: Date): string {
  const now = new Date();
  const secondsAgo = (now.getTime() - date.getTime()) / 1000;

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  if (secondsAgo < 60) {
    return `${Math.floor(Math.max(1, secondsAgo))}s`; // seconds ago
  } else if (secondsAgo < 3600) {
    return `${Math.floor(secondsAgo / 60)}m`; // minutes ago
  } else if (secondsAgo < 86400) {
    return `${Math.floor(secondsAgo / 3600)}h`; // hours ago
  } else if (now.getFullYear() === date.getFullYear()) {
    return `${monthNames[date.getMonth()]} ${date.getDate()}`; // Mon D
  } else {
    return `${
      monthNames[date.getMonth()]
    } ${date.getDate()}, ${date.getFullYear()}`; // Mon D, YYYY
  }
}

export function formatDateToHours(date: Date, showSeconds = false) {
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  if (showSeconds) {
    return `${hours}:${minutes}:${seconds}`;
  }

  return `${hours}:${minutes}`;
}

export function formatMessageDate(date: Date) {
  // if it's today, show hours, minutes
  // otherwise show date

  const now = new Date();
  const isToday = now.toDateString() === date.toDateString();
  if (isToday) {
    return formatDateToHours(date);
  }

  return formatPostDate(date);
}

export function formatIntlDate(
  dateString: Date,
  options: Intl.DateTimeFormatOptions = { dateStyle: "long" },
) {
  return new Intl.DateTimeFormat(undefined, options).format(
    new Date(dateString),
  );
}

export function formatElapsedTime(timestamp: number, divisor = 1000) {
  const elapsed = Math.floor(timestamp / divisor);

  if (elapsed === 0) {
    return `${elapsed}ms`;
  }
  if (elapsed < 60) {
    return `${elapsed}s`;
  } else if (elapsed < 3600) {
    return `${Math.floor(elapsed / 60)}m`;
  } else if (elapsed < 86400) {
    return `${Math.floor(elapsed / 3600)}h`;
  } else if (elapsed < 604800) {
    return `${Math.floor(elapsed / 86400)}d`;
  } else if (elapsed < 2592000) {
    return `${Math.floor(elapsed / 604800)}w`;
  } else if (elapsed < 31536000) {
    return `${Math.floor(elapsed / 2592000)}mo`;
  } else {
    return `${Math.floor(elapsed / 31536000)}y`;
  }
}

export function coerceDate(
  date: Date | string | number | undefined,
): Date | undefined {
  if (!date) {
    return undefined;
  }

  if (date instanceof Date) {
    return date;
  }

  if (typeof date === "string") {
    return new Date(date);
  }

  return new Date(date);
}
